(() => {
  if (window.__LDJ_PRODUCT_CARD_LOADED__) return;
  window.__LDJ_PRODUCT_CARD_LOADED__ = true;

  const initCard = (card) => {
    if (!card || card.dataset.cardInitialized === 'true') return;

    const video = card.querySelector('[data-product-card-video]');

    if (!video) {
      card.dataset.cardInitialized = 'true';
      return;
    }

    card.dataset.cardInitialized = 'true';

    const source = video.querySelector('source[data-src]');
    let loaded = false;

    const loadVideo = () => {
      if (loaded || !source) return;

      source.src = source.dataset.src;
      source.removeAttribute('data-src');

      video.load();
      loaded = true;
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          loadVideo();

          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      {
        threshold: 0.1
      }
    );

    observer.observe(card);
  };

  const initCards = (root = document) => {
    root
      .querySelectorAll('[data-product-card]')
      .forEach(initCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCards();
    });
  } else {
    initCards();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCards(event.target);
  });
})();
